export default "__VITE_ASSET__BDWqCLvN__"